export default "__VITE_ASSET__B4BUhe$t__"